import { Component } from '@angular/core';
import { NavController, LoadingController, NavParams, AlertController, ModalController, ToastController } from 'ionic-angular';
import { User, Master, Subscriber } from '@providers/index';

@Component({
  selector: 'page-list-notification',
  templateUrl: 'page.html'
})
export class ListNotificationPage {

  user:any={};
  params:any={};
  list:any=[];

  constructor(
    public navCtrl: NavController,
    public masterApi: Master,
    public userApi: User,
    public subsApi: Subscriber,
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController,
    public modalCtrl : ModalController,
    public navParams: NavParams,
    public alertCtrl: AlertController
    ) {
    
    this.user = this.userApi.data;
    this.params = {

    }
    
  }

  ionViewDidEnter(){
    this.getList();
  }

  doRefresh(refresher){
    refresher.complete();
    this.getList();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }
  
  getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params: any = {modul_id:4, user_id:this.user.user_id};
    this.subsApi.getNotifList(params).subscribe((resp:any) => {
      if (resp.data!=''){
        this.list = resp.data;
        loading.dismiss();
      }else{
        this.presentToast("Anda belum mendapat notifikasi");
        loading.dismiss();
      }
    }, (err) => {
      loading.dismiss();
    });
  }


}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/list_notification/page.ts